<template>
  <div :style="`max-height: ${height}px`" style="overflow: auto; margin-top:-4px">
    <v-infinite-scroll :items="dataChunk" @load="loadMoreData" direction="vertical" style="overflow-y:hidden">
      <div>
        <v-chip v-for="(item, index ) in dataChunk" 
          :key="index" 
          size="small" 
          label
          class="elevation-1 pa-1 ml-0 mr-1 mt-0 mb-1"
          rounded="xl"
          :class="isSelected(item) ? 'selected-chip' : 'default-chip'"
          @click="updateSelection(item)"
        >
          {{ item }}
        </v-chip>
      </div>
      <template v-slot:empty>
      </template>
    </v-infinite-scroll>
  </div>
  
</template>

<script>
export default {
  props: {
    allData: {
      type: Array,
      required: true
    },
    selections: {
      type: Array,
      default: []
    },
    height: {
      type: Number,
      default: 300
    },
  },
  data() {
    return {
      dataChunk: [],
      itemsPerChunk: 50,
    };
  },
  created() {
  },
  mounted() {
    this.createInitialChunk()
  },
  methods: {
    createInitialChunk(){
      this.dataChunk = this.allData.slice(0, this.itemsPerChunk)
    },
    loadMoreData({done}){
      if (this.dataChunk.length == this.allData.length){
        done('empty')
        return
      }
      const startIndex = this.dataChunk.length
      const endIndex = startIndex + this.itemsPerChunk
      const newData = this.allData.slice(startIndex, endIndex)
      this.dataChunk = this.dataChunk.concat(newData)
      done('ok')
    },
    isSelected(item){
      return this.selections.includes(item)
    },
    updateSelection(item) {
      let newSelections
      if (!this.selections.includes(item)) {
        newSelections = [...this.selections, item]
      } else {
        newSelections = this.selections.filter(i => i !== item)
      }
      this.$emit('updatedSelection', newSelections)
    },
  }
}
</script>

<style scoped>
.default-chip {
  background-color: white;
  color:  rgb(var(--v-theme-darkSlate));
}
.selected-chip {
  background-color: rgb(var(--v-theme-primary));
  color: white;
}
</style>